module.exports = __webpack_public_path__ + "img/2.d5ede11f.png";